import { Stack } from "@chakra-ui/react";

interface ILargeTemplateProps {
    children: React.ReactNode;
}

export default function LargeTemplate({ children }: ILargeTemplateProps) {
    return (
        <Stack 
            justifyContent={"center"} 
            alignItems={"center"} 
            width={"100%"}
        >
            <Stack 
                width={{
                    base:"100%",
                    sm:"90%",
                    md:"90%",
                    lg:"90%",
                    xl:"80%"
                }} 
                paddingY={{
                    base: 10,
                    sm: 10,
                    md: 10,
                    lg: 20,
                    xl: 20,
                }}
            >
                {children}
            </Stack>
        </Stack>
    );
}